module.exports = __webpack_public_path__ + "img/1726043569668-screenshot-1726043547853.png.ea725621.webp";